export * from '@primeuix/themes/nora/tooltip';
export { default } from '@primeuix/themes/nora/tooltip';
